import { Color } from '@diritto/common/style/color';
import { LocalStorageKey } from '@diritto/common/utils/localStorage';
import {
  ViewerFont,
  ViewerFontSize,
  ViewerLineHeight,
  ViewerOptionKey,
  ViewerPadding,
  ViewerParagraphIndent,
  ViewerStyle,
  ViewerTheme,
  ViewerViewType,
} from '@diritto/common/viewer/constants/viewer.constant';

export interface OldViewerStyle {
  theme: ViewerTheme;
  font: ViewerFont;
  fontSize: ViewerFontSize;
  lineHeight: ViewerLineHeight;
  paragraphIndent: ViewerParagraphIndent;
  padding: ViewerPadding;
  indentation: boolean;
}
export const ViewerOptionKeyToLocalStorageKey = {
  [ViewerOptionKey.Theme]: LocalStorageKey.ViewerTheme,
  [ViewerOptionKey.Font]: LocalStorageKey.ViewerFont,
  [ViewerOptionKey.FontSize]: LocalStorageKey.ViewerFontSize,
  [ViewerOptionKey.LineHeight]: LocalStorageKey.ViewerLineHeight,
  [ViewerOptionKey.ParagraphIndent]: LocalStorageKey.ViewerParagraphIndent,
  [ViewerOptionKey.Padding]: LocalStorageKey.ViewerPadding,
  [ViewerOptionKey.Indentation]: LocalStorageKey.ViewerIndentation,
  [ViewerOptionKey.ViewType]: LocalStorageKey.ViewerViewType,
  [ViewerOptionKey.FancyShare]: LocalStorageKey.ViewerFancyShare,
};

export const ViewerFontBasic = {
  lineHeight: 1.6,
  paragraphIndent: 1,
};

export const ViewerThemeTitle = {
  [ViewerTheme.White]: '화이트',
  [ViewerTheme.Sepia]: '세피아',
  [ViewerTheme.DarkGray]: '그레이',
  [ViewerTheme.Black]: '블랙',
  [ViewerTheme.DirittoGreen]: '그린',
};

export const ViewerThemeColorSet: {
  [key: string]: {
    color: Color;
    logoColor: Color;
    backgroundColor: Color;
  };
} = {
  [ViewerTheme.White]: {
    color: Color.Black,
    logoColor: Color.Black,
    backgroundColor: Color.White,
  },
  [ViewerTheme.Sepia]: {
    color: Color.Black,
    logoColor: Color.Black,
    backgroundColor: Color.SepiaBg,
  },
  [ViewerTheme.DarkGray]: {
    color: Color.DarkGrayTxt,
    logoColor: Color.White,
    backgroundColor: Color.DarkGrayBg,
  },
  [ViewerTheme.Black]: {
    color: Color.BlackTxt,
    logoColor: Color.White,
    backgroundColor: Color.DarkBg,
  },
  [ViewerTheme.DirittoGreen]: {
    color: Color.Black,
    logoColor: Color.Black,
    backgroundColor: Color.DirittoGreen,
  },
};

export const ViewerThemeDimColor = {
  [ViewerTheme.White]: '#B2B2B2',
  [ViewerTheme.Sepia]: '#ACA9A0',
  [ViewerTheme.DarkGray]: '#323232',
  [ViewerTheme.Black]: '#121212',
  [ViewerTheme.DirittoGreen]: '#8E9C8B',
};

export const oldInitialStyle: OldViewerStyle = {
  theme: ViewerTheme.White,
  font: ViewerFont.RidiBatang,
  fontSize: ViewerFontSize.Level6,
  lineHeight: ViewerLineHeight.Level1,
  paragraphIndent: ViewerParagraphIndent.Level4,
  padding: ViewerPadding.Level3,
  indentation: false,
};

export const initialStyle: ViewerStyle = {
  [ViewerOptionKey.Theme]: ViewerTheme.White,
  [ViewerOptionKey.Font]: ViewerFont.RidiBatang,
  [ViewerOptionKey.FontSize]: ViewerFontSize.Level6,
  [ViewerOptionKey.LineHeight]: ViewerLineHeight.Level1,
  [ViewerOptionKey.ParagraphIndent]: ViewerParagraphIndent.Level4,
  [ViewerOptionKey.Padding]: ViewerPadding.Level3,
  [ViewerOptionKey.Indentation]: false,
  [ViewerOptionKey.ViewType]: ViewerViewType.Scroll,
  [ViewerOptionKey.FancyShare]: true,
};
